import React, {useEffect, useState} from "react";
import {Fab, Paper, StyledComponentProps, Typography, withStyles} from "@material-ui/core";
import {defaultStyles} from "../../../styles/defaultStyles";
import TabSpinner from "../../common/TabSpinner";
import {apiInstance} from "../../../api/Api";
import SettingsTableHeader from "../../common/SettingsTableHeader";
import AddContainer from "../../common/AddContainer";
import {none} from "ts-option";
import PartUnitsModal from "./PartUnitsModal";
import AddIcon from '@material-ui/icons/Add';
import PartUnit from "../../../models/PartUnit";
import PartUnitsTable from "./PartUnitsTable";

type IProps = StyledComponentProps

const PartUnits: React.FunctionComponent<IProps> = (props: IProps) => {

    const [isLoading, setLoading] = useState<boolean>(true);
    const [isOpen, setOpen] = useState<boolean>(false);
    const [partUnits, setPartUnits] = useState<PartUnit[]>([]);

    const fetchData = async () => {
        const partUnits = await apiInstance.partsApi.fetchPartUnits();
        setPartUnits(partUnits)
    };

    const onClose = () => {
        setOpen(false);
        fetchData().then()
    };

    useEffect(() => {
        fetchData()
            .then(() => setLoading(false))
            .catch(() => {
                // TODO Handle error
                setLoading(false)
            });
    }, []);

    const {classes}: any = props;
    return (
        <Paper className={classes.settingsTablePaper}>
            {isLoading ?
                <TabSpinner/> :
                <>
                    <SettingsTableHeader>
                        <Typography variant={"h6"}>Part Units</Typography>
                    </SettingsTableHeader>
                    <PartUnitsTable partUnits={partUnits} onClose={onClose}/>
                    <AddContainer>
                        <Fab size={"small"} color={"primary"} onClick={() => setOpen(true)}><AddIcon/></Fab>
                    </AddContainer>
                    <PartUnitsModal isOpen={isOpen}
                                    partUnit={none}
                                    onClose={() => onClose()}/>
                </>
            }
        </Paper>
    );
};

export default withStyles(defaultStyles)(PartUnits);